import React, { FC, useMemo } from 'react'
import Select from 'react-select'
import { managerSelectStyles } from '../FilterDropdown.styles'

export type AccountStatusFilterValue = 'ALL' | 'ACTIVE' | 'DELETED'

type AccountStatusOption = {
  label: string
  value: AccountStatusFilterValue
}

const options: AccountStatusOption[] = [
  { label: 'Account status', value: 'ALL' },
  { label: 'Active', value: 'ACTIVE' },
  { label: 'Inactive', value: 'DELETED' },
]

interface Props {
  value: AccountStatusFilterValue
  onChange: (value: AccountStatusFilterValue) => void
  closeMenuOnScroll?: (event: Event) => boolean
}

export const AccountStatusFilter: FC<Props> = ({ value, onChange, closeMenuOnScroll }) => {
  const selectedOption = useMemo(
    () => options.find(option => option.value === value) || options[0],
    [value],
  )

  return (
    <Select<AccountStatusOption, false>
      styles={managerSelectStyles}
      options={options}
      value={selectedOption}
      onChange={opt => {
        if (opt) onChange(opt.value)
      }}
      isSearchable={false}
      classNamePrefix="account-status-select"
      menuPosition="absolute"
      closeMenuOnScroll={closeMenuOnScroll}
    />
  )
}

export const isInactiveAccountStatus = (status?: string): boolean => {
  const normalized = (status || '').toUpperCase()
  return normalized === 'DELETED' || normalized === 'INACTIVE' || normalized === 'NOT_IN_SYSTEM'
}

export const formatAccountStatus = (status: string): string => {
  if (!status) return '-'
  const normalized = status.toUpperCase()
  if (normalized === 'ACTIVE') return 'Active'
  if (isInactiveAccountStatus(status)) return 'Inactive'
  return status
}
